import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { PurchaseTermsConditionTrackingService } from '../../../services/purchase-terms-condition-tracking.service';

@Component({
  selector: 'app-purchase-terms-and-condition',
  templateUrl: './purchase-terms-and-condition.component.html',
  styleUrl: './purchase-terms-and-condition.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PurchaseTermsAndConditionComponent implements OnInit {

  public componentData: CmsParagraphComponent;

  constructor(
    public component: CmsComponentData<CmsParagraphComponent>,
    private purchaseTncTrackingService: PurchaseTermsConditionTrackingService
  ) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
    this.purchaseTncTrackingService.pageLoadTrackingData();
  }
}
